
rs.module("controls/data/grid",

    ["controls/framework/ag/agNameValueHelper"],

    function (nameValueHelper) {

        var _gridLicense = "Using_this_{AG_Grid}_Enterprise_key_{AG-088252}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Levi_Ray_&_Shoup_Inc}_is_granted_a_{Multiple_Applications}_Developer_License_for_{20}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{4}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_September_2026}____[v3]_[01]_MTc4ODU2MjgwMDAwMA==cf54189c165bad6e001e95750fcd99d7";

        // This is our private\internal column name added on to each data row that is selected.
        var _selectedColumnName;

        // This is our private\internal column name added on to each data row that was POST'd with a change and has model state being sent back down to the grid.  
        var _changeIdColumnName;

        // This is the marker to use to indicate the presence of the form element for grid selection when there is no selection.  Without this we couldn't tell
        // the difference between the grid not existing and nothing being selected.  This was made necessary by the wizard which preserves the same model from step
        // to step, and if we didn't know the grid was there with nothing selected, and existing collection would not be cleared.
        var _formFieldPresenceIndicator;

        // The value assigned to the hidden input for client-side jquery validation
        var _clientValidationMarkerValue;

        // The CSS class applied to the span when the contents are unmasked
        var _maskedDataUnmaskedCssClass;

        // Maximum number of rows to load into the grid during its first initialization while the page is still loading.  This keeps the page responsive
        // and not delayed too long waiting for the grid to process a ton of rows.  The remaining rows get added in after the page is fully visible.
        // Decreasing this could slightly improve page load perception.  The cost is that the vertical scrollbar of the grid will make bigger and bigger "jumps"
        // once the full dataset is loaded.
        var _maxRowsForInitialLoad = 200;

        // State flags for inline editing
        // NOTE: Must match the assigned enum values in GridEditingChangeType.cs
        var InlineEditingState = {
            original: 0,
            edited: 1,
            added: 2,
            deleted: 3
        };

        // For finding dates that are sent down in JSON as strings, so that we can rehydrate them into Date objects that the grid needs
        const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.000$/;

        var _httpHeaderNames;
        var _markers;

        //
        // Initialize the grid
        //
        function initialize(gridContainer, gridProperties, httpHeaderNames, markers) {

            // Find the grid <div>.  gridContainer could either be a selector, or the container itself depending on if we are being initialized as a normal grid
            // or as a detail grid from a master\detail situation
            var gridDiv = (gridContainer instanceof jQuery) ? gridContainer : $.js(gridContainer.grid);

            _markers = markers;
            _httpHeaderNames = httpHeaderNames;

            // Store the markers
            _selectedColumnName = markers.selectedColumnName;
            _changeIdColumnName = markers.changeIdColumnName;
            _formFieldPresenceIndicator = markers.formFieldPresenceIndicator;
            _clientValidationMarkerValue = markers.clientValidationMarkerValue;
            _maskedDataUnmaskedCssClass = markers.maskedDataUnmaskedCssClass;

            agGrid.LicenseManager.setLicenseKey(_gridLicense);

            // As of ag v33 we can no longer have our own custom properties outside of context - this finds all of those and moves them into the context
            _prepareContext(gridProperties);

            // Do initial prep for our "pg" properties
            _preparePgProperties(gridProperties);

            // Prepare general defaults on grid properties
            _prepareDefaults(gridProperties);

            // Prepare things for being able to be exported to excel
            _prepareExporting(gridProperties);

            // Prepare for grid editing - this stuff must be done before initializing the grid
            _prepareEditing(gridProperties);

            // Prepare for master\detail - must be done before initializing the grid
            _prepareMasterDetail(gridProperties);

            // Prepare for grand totals - this portion must be done before grid initialization
            _prepareGrandTotals(gridProperties);

            // Selection and Totals need to be after all data is loaded, which may be delayed if we are postponing loading the full set of rows for performance.  We use
            // this for indirection to control if they are done immediately or need to be done async.
            var selectionInitializer = _initializeSelection;
            var grandTotalsInitializer = _initializeGrandTotals;

            // If the document is not ready yet, which would be the case during a normal page load with a grid, optimize for page responsiveness.
            // When a grid is initialized as a result of an ajax call producing html, the page is already loaded so we can't optimize by partially
            // loading rows and completing them in the window load event.
            if (document.readyState != "complete") {

                // Save the full row data for later, and load the grid with the first _maxRowsForInitialLoad rows of data. This keeps the grid snappy on initial load
                // by minimizing the rows it has to process, and is also enough rows to do our exact\autoheight calculations.  The user won't really
                // notice that all the rows aren't there for a half-second or whatever it is.  Biggest "flash" would be the vertical scrollbar
                // getting bigger once all the data is in.
                if (gridProperties.rowData.length > _maxRowsForInitialLoad) {

                    var allRows = gridProperties.rowData;
                    gridProperties.rowData = allRows.slice(0, _maxRowsForInitialLoad);

                    // Selection and grand totals have to be delayed until after load
                    selectionInitializer = function (...args) { $(window).on('load', function () { _initializeSelection(...args); }); };
                    grandTotalsInitializer = function (...args) { $(window).on('load', function () { _initializeGrandTotals(...args); }); };

                    // Wait until everything in the window is fully rendered before loading the rest of the rows, that way the grid loading (potentially) a lot
                    // more data doesn't slow anything down.
                    $(window).on('load', function () {
                        agGridApi.updateGridOptions({ rowData: allRows });
                        
                    });
                }

            }

            // Prepare keyboard navigation - this is done before initializing the grid
            _prepareKeyboardNavigation(gridProperties);

            // Listen for every time the grid creates a new row node.  We then invoke all the callbacks registered using _listenForCreatedRowNodes
            gridProperties.processRowPostCreate = _onProcessPostRowCreate;

            // initialize agGrid with it and the configured options
            var agGridApi = agGrid.createGrid(gridDiv[0], gridProperties);

            // Put the api onto the properties just for convenience so as we are passing properties we don't have to pass the api too
            gridProperties.agGridApi = agGridApi;

            // Add on our pg specific properties to the ag grid API
            _initializePgProperties(agGridApi, gridDiv);
             
            // Initialize grid selection options
            selectionInitializer(agGridApi, gridDiv);

            // Configure column sizing
            _initializeColumnSizing(gridProperties, gridDiv, gridProperties.context["_lrs/columnSizing"]);

            // Initialize the height system
            _initializeHeightManagement(agGridApi, gridDiv, gridProperties.context["_lrs/height"]);

            // Initialize editing
            _initializeEditing(gridProperties);

            // Initialize grand totals
            grandTotalsInitializer(gridProperties);

            // If there are any fixed columns we need to pin and unpin them as other columns are pinned and unpinned to make sure they
            // stay all the way to the left.
            var fixedColumns = agGridApi.getAllGridColumns().filter(function (column) { return column.getColDef().lockPosition; });
            if (fixedColumns.length > 0) {
                agGridApi.addEventListener("columnPinned", _onColumnPinned);
            }

            var lrsGridApi = _createLrsGridApi(agGridApi);

            // Stuff the lrsGridApi and our moduleApi onto the agGridApi so we can always get to them
            agGridApi.lrsGridApi = lrsGridApi;
            agGridApi.moduleApi = this;

            // Exported LRS API
            return lrsGridApi;
        }

        //
        // As of ag v33 we can no longer have our own custom properties outside of context - this finds all of those and moves them into the context
        //
        function _prepareContext(properties, contextToUse) {

            // If the properties we were passed has a context property we use that, otherwise just use what was passed in \ inherited
            if (properties.context) {
                contextToUse = properties.context;
            }

            for (let key in properties) {

                var value = properties[key];

                // If its a special "_lrs/" key (custom context), then we move it from where it's add to the context object
                if (key.startsWith("_lrs/")) {

                    // Copy this key\value into our context
                    contextToUse[key] = value;

                    // Now delete it from the original object to make ag-grid happy
                    delete properties[key];
                }

                // Otherwise if its an object that may have it's own child properties, recurse into it.
                // (We exclude recursing into context objects and HTML elements)
                else if (key != "context" && value && typeof value === "object" && value.nodeType === undefined) {
                    _prepareContext(value, contextToUse);
                }
            }
        }

        //
        // Do initial prep work on the gridProperties to prepare for adding our 'pg' properties, but before the grid API is created
        //
        function _preparePgProperties(gridProperties) {

            // Go ahead and create our special 'pg' object off of the context
            var pg = gridProperties.context.pg = {};

            // We also set the 'gridOptions' property early and now, because in some cases the chain of events that gets kicked off by "createGrid" causes
            // other callbacks we have to get called that need that property, but we haven't had a chance to call _initializePgProperties yet because
            // no API exists
            pg.gridOptions = gridProperties;
        }

        //
        // Add on our pg specific properties to the ag grid API
        //
        function _initializePgProperties(agGridApi, gridDiv) {

            // First create the pg properties on this API
            _createPgProperties(agGridApi, gridDiv);

            // Then create the pg accessor to get to them
            _createPgPropertyAccessor(Object.getPrototypeOf(agGridApi));
        }

        //
        // Create the pgProperties instance on the given agGridApi instance
        //
        function _createPgProperties(agGridApi, gridDiv) {

            var pg = agGridApi.getGridOption("context").pg;

            // This is the not the main grid div, but the inner body div with class of "ag-root"
            pg.gridBody = gridDiv.find(".ag-root")[0];

            // This is the div that has a class of "ag-body-viewport" within "ag-root"
            pg.gridBodyViewport = gridDiv.find(".ag-body-viewport")[0];

            // The header component, class of "ag-header" within "ag-root"
            pg.gridHeader = gridDiv.find(".ag-header")[0];

            // The floating top and bottom pieces, which contained the pinned rows if any, "ag-floating-top" and "ag-floating-bottom"
            pg.gridPinnedTop = gridDiv.find(".ag-floating-top")[0];
            pg.gridPinnedBottom = gridDiv.find(".ag-floating-bottom")[0];

            // This is the scrollbar at the bottom of the grid, classed as "ag-body-horizontal-scroll"
            pg.gridHorizontalScroll = gridDiv.find(".ag-body-horizontal-scroll")[0];
            pg.gridVerticalScroll = gridDiv.find(".ag-body-vertical-scroll")[0];
        }

        //
        // Create the "pg" accessor on the ag-grid API -prototype-, not on the API itself.  This way it works on every single API object
        // ag grid creates
        //
        function _createPgPropertyAccessor(agGridApiPrototype) {

            // Make sure we haven't already been here before - the prototype is for all instances, so only need to add once
            if (agGridApiPrototype.hasOwnProperty("pg")) {
                return;
            }

            // Add our special pg accessor that will enable us to get to all the internal\private ag-grid stuff through one spot
            Object.defineProperty(agGridApiPrototype, "pg",
                {
                    get: function () {

                        // The agGridApi prototype is a constructor with all the grid api functions, sometimes we come through here with that as the 'this' right
                        // before we come through here with the actual agGridApi instance.  The prototype will have a 'constructor' property on it.  So if "constructor"
                        // is present, this isn't actually a gridApi instance and we bail
                        if (this.hasOwnProperty("constructor")) {
                            return;
                        }

                        // 'this' will be the agGridApi instance we are being called for
                        return this.getGridOption("context").pg;
                    }
                }
            );
        }

        //
        // Get the grid options giving the grid api
        function _gridOptions(agGridApi) {

            // We are not using our custom pg object here b\c our custom pg object uses us, and sometimes we get used
            // during grid initialization before the pg object is available.
            return agGridApi.getGridOption("context").pg.gridOptions;
        }

        //
        // Create the instance api that can be used to interact with this specific grid instance
        //
        function _createLrsGridApi(agGridApi) {

            var lrsGridApi = {
                agGridApi: agGridApi
            };

            var selectionValueProperty = _getSelectionValueProperty(agGridApi);

            // Add selectedValues getter\setter
            Object.defineProperty(lrsGridApi, 'selectedValues',
                {
                    get: function () {
                        return agGridApi.getSelectedRows().map(row => row[selectionValueProperty]);
                    },
                    set: function (values) {

                        // If null, create an empty array
                        if (!values && values !== 0) {
                            values = [];
                        }

                        // If its a single value, wrap in an array
                        if (!Array.isArray(values)) {
                            values = [values];
                        }

                        // Now we can loop through the array and select everything
                        agGridApi.forEachNode(function (node) {
                            if (!node.group) {

                                var selected = values.includes(node.data[selectionValueProperty]);

                                node.setSelected(selected);
                            }
                        });
                    }
                });

            // Getter for getting selection with full row data
            Object.defineProperty(lrsGridApi, 'selectedRows',
                {
                    get: function () { return agGridApi.getSelectedRows(); }
                });

            //
            // Selection changed event
            //
            lrsGridApi.selectionChanged = function (handler) {

                function callback() {
                    handler.call(lrsGridApi, lrsGridApi.selectedValues, lrsGridApi.selectedRows);
                };

                agGridApi.addEventListener("selectionChanged", callback);

                // Call the handler right away for whatever selection we currently have
                callback();
            };

            //
            // Row clicked event
            //
            lrsGridApi.rowClicked = function (handler) {

                function callback() {
                    handler.call(lrsGridApi, lrsGridApi.selectedValues, lrsGridApi.selectedRows);
                };

                agGridApi.addEventListener("rowClicked", callback);
            };

            //
            // Select the first row of the grid
            //
            lrsGridApi.selectFirstRow = function () {
                agGridApi.forEachNode(function (node) {
                    if (!node.group) {
                        node.setSelected(node.rowIndex == 0);
                    }
                });
            };

            //
            // Clear the grid row data
            //
            lrsGridApi.clearGridRows = function () {
                _updateRowDataPreservingFilter(agGridApi, null);
            };

            // 
            // Adds a new row to the grid and initiates inline editing on it.  
            // If "defaults" is provided it is used as the default data for the new row.
            // If "commitImmediately" is true, the row will not be in a pending state and will be saved.
            //
            lrsGridApi.addRow = function (defaults, commitImmediately) {
                _onInlineEditingAddRow.call(agGridApi, defaults, commitImmediately);
            }

            //
            // Inline edits a row, changing values to those provided.
            // 
            lrsGridApi.updateRow = function (node, values) {
                // update the underlying data 
                for (const name in values) {
                    node.setDataValue(name, values[name])
                }

                // mark the row as edited
                _onRowInlineEditSaved({ api: agGridApi, node: node, data: node.data });

                setTimeout(function () { agGridApi.refreshClientSideRowModel() }, 0);
            }

            //
            // Callback for when the grid row has been inline edited, either edited, deleted, or added.
            // handler is expected to be a function that takes a single 'change' parameter.  The 'change' object has the following:
            //   edited: bool indicating if this change is an edit
            //   added: bool indicating if this change is an add
            //   deleted: bool indicating if this change is a delete
            //   original: bool indicating if the row was brought back to its original state (after Cancel or Undo)
            //   oldData: The previous data for the node before the edit, or null for adds
            //   newData: The new data after the change, or null for deletes
            //   accept(): Function to tell the grid the change has been processed and accepted
            //   reject(): Function to tell the grid the change has been processed and rejected.  The grid will roll back to the original data.
            //
            lrsGridApi.rowChanged = function (handler) {

                // Store the change callback on the agGridApi so we can notify when its time
                agGridApi.inlineEditingRowChangedCallback = function (change) {
                    handler.call(lrsGridApi, change);
                };
            };

            //
            // Get the list of outstanding inline editing changes. This is a list of 'change' objects, each of which has the following:
            //   edited: bool indicating if this change is an edit
            //   added: bool indicating if this change is an add
            //   deleted: bool indicating if this change is a delete
            //   original: bool indicating if the row was brought back to its original state (after Cancel or Undo)
            //   oldData: The previous data for the node before the edit, or null for adds
            //   newData: The new data after the change, or null for deletes
            //   accept(): Function to tell the grid the change has been processed and accepted
            //   reject(): Function to tell the grid the change has been processed and rejected.  The grid will roll back to the original data.
            //
            lrsGridApi.getChanges = function () {
                return _getInlineEditedNodes(agGridApi).map(rowNode => _createInlineEditingChangeInstance(agGridApi, rowNode));
            };

            //
            // The grid will accept all inline editing changes (clears the editing display\state)
            //
            lrsGridApi.acceptChanges = function () {
                _inlineEditingAcceptChanges(agGridApi);
            };

            //
            // The grid will reject all inline editing changes (clears the editing display\state, and rolls back to the original data)
            //
            lrsGridApi.rejectChanges = function () {
                _inlineEditingRejectChanges(agGridApi);
            };

            return lrsGridApi;
        }


        //
        // Attach a handler to the "formdata" event that automatically makes sure that a form exists and that the grid is still apart of the page
        //
        function _attachFormDataHandler(agGridApi, handler) {

            var gridBody = $(agGridApi.pg.gridBody)

            var form = gridBody.closest("form");
            if (!form.exists()) {
                return;
            }

            // attach to the formdata event
            form.on("formdata", { handler: _onFormData }, _onFormData);

            // The callback
            function _onFormData(e) {
                // if the grid is no longer part of the page, do not add
                // form values
                if (!document.body.contains(gridBody[0])) {

                    // detach this handler instance so it doesn't happen again
                    form.off('formdata', e.data.handler);
                    return;
                }

                // Get the form data from the event object
                handler(e.originalEvent.formData, agGridApi);
            }
        }

        //
        // If hosted inside a form, this hooks up the grid to participate as if it were a native html control
        //
        function _initializeSelection(agGridApi, gridDiv) {

            if (!agGridApi.pg.gridOptions.rowSelection) {
                return;
            }

            // Select the initial selection
            _selectRowsMarkedForSelection(agGridApi);

            // If no rows were selected, but selection is required, select the first
            if (agGridApi.getSelectedRows().length == 0 &&  agGridApi.pg.gridOptions.context["_lrs/selection/required"]) {
                agGridApi.forEachNode(function (node) {
                    if (!node.group) {
                        node.setSelected(node.rowIndex == 0);
                    }
                });
            }

            var postToName = agGridApi.pg.gridOptions.context["_lrs/selection/postToName"];

            // If selection hasn't been configured there won't be a postToName
            if (postToName) {

                var form = gridDiv.closest("form");
                if (!form.exists()) {
                    return;
                }

                // Find the fake input that validation will actually be ran on
                var validationTarget = gridDiv.children("input").first(`[name='${postToName}']`);

                // But we do want to try to validate it as valid when the selection changes if its currently invalid
                agGridApi.addEventListener("selectionChanged", function () {
                    if (validationTarget.hasClass("input-validation-error")) {
                        form.validate().element(validationTarget);
                    }
                });

                // Has to be within the $(), otherwise validation isn't yet setup and rules doesn't exist.
                $(function () {

                    // jQuery validation by default ignores hiddens... which are target is, so we rectify that and make sure to explicitly include ourselves. There may be other
                    // hidden elements with our same name (like if we are trying to pass a key from form to form and that key is also the selection value
                    // for this grid.  So we make sure to scope it just to hidden inputs with our name inside the grid div)
                    $.validator.include(`.grid:not(:hidden) > input[name='${postToName}']`);

                    // Our input validationTarget doesn't contain any real value, so we need a normalizer to give it it's value, which
                    // is the grid's list of selected items.
                    validationTarget.rules("add", {
                        normalizer: function () {
                            return agGridApi.lrsGridApi.selectedValues;
                        }
                    });
                })

                _attachFormDataHandler(agGridApi,
                    function (formData) {

                        var valueProperty = _getSelectionValueProperty(agGridApi);
                        var selectedRows = agGridApi.getSelectedRows();

                        // We do not want to send along our fake validation value if it is in there
                        _deleteFormDataEntry(formData, postToName, _clientValidationMarkerValue);

                        // If nothing is selected, still post an empty value.  Otherwise the data binding mechanism doesn't know the difference
                        // between this grid existing at all vs. not having any selection.  This came up as an issue with the Wizard since it preserves
                        // the same model instance from step to step.  This basically mimicks the asp.net core method of adding a hidden input for checkboxes
                        // that is always false to fallback on.
                        if (selectedRows.length == 0) {
                            var rowSelection = agGridApi.pg.gridOptions["rowSelection"];
                            formData.append(postToName, (rowSelection && rowSelection.mode == "singleRow") ? "" : _formFieldPresenceIndicator);
                        }
                        else {
                            selectedRows.forEach(function (row) {
                                formData.append(postToName, row[valueProperty]);
                            });
                        }

                    });
            }
        }

        //
        // Select all rows marked for selection with our special selected column sent down by the server-side
        //
        function _selectRowsMarkedForSelection(agGridApi) {
            agGridApi.forEachNode(function (node) {
                if (!node.group) {
                    node.setSelected(node.data[_selectedColumnName] === true);
                }
            });
        }

        //
        // Get the value property used for selection
        //
        function _getSelectionValueProperty(agGridApi) {

            var gridProperties = agGridApi.pg.gridOptions;
            if (!gridProperties.rowSelection) {
                return null;
            }

            var selectionValueProperty = gridProperties.context["_lrs/selection/valueProperty"];
            return selectionValueProperty;
        }

        //
        // Prepare the grid grand totals, before grid initialization
        //
        function _prepareGrandTotals(gridProperties) {

            // See if we have a grandtotals row
            if (gridProperties.pinnedBottomRowData) {

                var overrides = gridProperties.pinnedBottomRowData[0]._grandTotalsOptions.overrides;

                gridProperties.columnDefs.forEach(function (column) {

                    // If this column has a renderer, but a grand totals override, then we need to wrap the renderer so it doesn't
                    // get used for the grand totals row.
                    if (column.cellRenderer instanceof Function && overrides.hasOwnProperty(column.field)) {
                        var actualRenderer = column.cellRenderer;

                        column.cellRenderer = function (params) { return (params.node.rowPinned == "bottom") ? params.value : actualRenderer(params); };
                    }
                });
            }
        }

        //
        // Initialize the grand totals, if configured
        //
        function _initializeGrandTotals(gridProperties) {

            // See if we have a grandtotals row
            if (gridProperties.pinnedBottomRowData) {

                var agGridApi = gridProperties.agGridApi;

                // Save the grand-totals updater onto the grid api, we'll need it later
                agGridApi._updateGrandTotals =
                    function updateGrandTotals(event) {
                        _calculateGrandTotals(event.api, gridProperties.pinnedBottomRowData[0]._grandTotalsOptions);
                    };

                // Call updater to set initial grand totals
                agGridApi._updateGrandTotals({ api: agGridApi });

                // Listen for filtering changes to update the totals
                agGridApi.addEventListener("filterChanged", agGridApi._updateGrandTotals);
            }
        }

        //
        // Initialize our grid height management stuff
        //
        function _initializeHeightManagement(agGridApi, gridDiv, heightOptions) {

            if (!heightOptions) {
                return;
            }

            // If filling space or using our own css, it's all via css
            if (heightOptions.strategy == "fillspace" || heightOptions.strategy == "viacss") {
                return;
            }

            // Get the height of the "frame" of the grid (the header, footer, etc)
            function getFrameHeight() {

                var borders = 2;

                // Get the header height
                var header = $(agGridApi.pg.gridHeader).is(":visible") ? agGridApi.pg.gridHeader.offsetHeight : 0;

                // 'ag-floating-top' and 'ag-floating-bottom'
                var top = agGridApi.pg.gridPinnedTop.offsetHeight;
                var bottom = agGridApi.pg.gridPinnedBottom.offsetHeight;

                // Can't use offsetHeight here.  Depending on the display scaling, this was returning different values on each call.  I guess
                // the browser was rounding up sometimes and down the next? It was making the grid twerk and look stupid.  So we just get
                // what the height is actually intended to be, and that solves it.
                var scroll = ($(agGridApi.pg.gridHorizontalScroll).hasClass("ag-hidden") || $(agGridApi.pg.gridHorizontalScroll).hasClass("d-none"))
                    ? 0
                    : parseInt($(agGridApi.pg.gridHorizontalScroll).css("height"), 10);

                var frameHeight = header + top + bottom + scroll + borders;

                return frameHeight;
            }

            // Get the height in px required to display the given count (the unit of 'count' is determined by heightOptions)
            function getHeightForCount(count) {

                var frameHeight = getFrameHeight();
                var lineHeight = agGridApi.getSizesForCurrentTheme().rowHeight;

                var resultHeight;

                // If its just based on lines, its an easy deterministic calculation...
                if (heightOptions.unit == "lines") {
                    resultHeight = frameHeight + (lineHeight * count);
                }
                // If its based on rows, we need to get the height of the first [count] nodes
                else {

                    var { nodeHeight, nodeCount } = getTotalNodeHeight(_.bind(agGridApi.forEachNodeAfterFilterAndSort, agGridApi), count);

                    // Pad with our basic line height of the count desired is more than the number of nodes
                    if (nodeCount < count) {
                        nodeHeight += (count - nodeCount) * lineHeight;
                    }

                    resultHeight = frameHeight + nodeHeight;
                }

                if (Number.isNaN(resultHeight)) {
                    throw Error("'getHeightForCount' produced an invalid height.  Did ag-grid break something again?");
                }

                return resultHeight;
            }

            // Function to update the height - will be defined by the specifc strategy
            var updateHeight = null;

            // The grid will size itself to exactly fit the rows within it.
            if (heightOptions.strategy == "autoheight") {

                updateHeight = function updateHeight() {

                    var { nodeHeight, nodeCount } = getTotalNodeHeight(_.bind(heightOptions.adjustToFiltering ? agGridApi.forEachNodeAfterFilterAndSort : agGridApi.forEachNode, agGridApi));
                    var height = getFrameHeight() + nodeHeight;

                    // Apply the minimum
                    if (heightOptions.minimum) {
                        height = Math.max(height, getHeightForCount(heightOptions.minimum));
                    }

                    // Apply the maximum
                    if (heightOptions.maximum) {
                        height = Math.min(height, getHeightForCount(heightOptions.maximum));
                    }

                    gridDiv.height(height);
                }
            }

            // Show an exact number of rows\lines
            if (heightOptions.strategy == "showexactly") {

                updateHeight = function updateHeight() {
                    gridDiv.height(getHeightForCount(heightOptions.count));
                }
            }

            // The grid will have no height of its own initially, but we need it to so we can determine what the height
            // of its frame is.  200 is arbitrary, just needs to be larger than the frame will be.
            gridDiv.height(200);

            // Apply the height
            updateHeight();

            // We always have to keep the height updated when columns are resized, because column resizing can trigger the horizontal scroll
            // to appear\dissappear, and when that happens we need to update the height to account for it.  These events can come in fast
            // and furious so we throttle them
            ["gridSizeChanged", "columnResized"].forEach(function (name) {
                agGridApi.addEventListener(name, _.throttle(updateHeight, 10));
            });

            // The height can change when sorting\filtering\column visiblity.  This could be due to varying row heights when sorting, or of course
            // rows being added\removed for filtering.  These events fire once so we don't need to throttle.
            ["modelUpdated", "columnVisible", "columnPinned"].forEach(function (name) {
                agGridApi.addEventListener(name, updateHeight);
            });
        }

        // Get the total height of the nodes provided by the callback, limiting to the first 'maxNodes' count.  'maxNodes' can be null
        // to specify no max.  Returns an object with properties of .nodeHeight and .nodeCount (which represents the total number of nodes counted)
        function getTotalNodeHeight(nodeCallback, maxNodes) {

            var height = 0;
            var count = 0;

            nodeCallback(function (node, index) {

                // As far as counting goes, only the top-level counts.
                count++;

                // Keep going until we hit our max (if there is one).  node will usually also become null on the first pass, unless there is master\detail displayed
                while ((!maxNodes || index < maxNodes) && node != null) {

                    height += node.rowHeight;

                    // See if there are detail nodes to dive into that are visible
                    node = (node.detailNode != null && node.detailNode.displayed) ? node.detailNode : null;
                }
            });

            return { nodeHeight: height, nodeCount: count };
        }

        //
        // Prepare the master\detail values in the gridProperties before its sent to the grid for initialization
        //
        function _prepareMasterDetail(gridProperties) {

            if (!gridProperties["masterDetail"]) {
                return;
            }

            // Setup custom rendering components
            gridProperties.components = gridProperties.components || {};

            gridProperties.components["MasterDetailRenderer"] = MasterDetailRenderer;

            // Detail renderer will use our custom component
            gridProperties.detailCellRenderer = "MasterDetailRenderer";

            var templateUrl = gridProperties.context["_lrs/masterDetail/templateUrl"];
            var gridUrl = gridProperties.context["_lrs/masterDetail/gridUrl"];

            // Setup the detail rendering
            gridProperties.detailCellRendererParams = function (renderer) {

                var agGridApi = renderer.api;

                var options = {
                    httpHeaderNames: _httpHeaderNames,
                    markers: _markers
                };

                // If there is a template, provide the template callback
                if (templateUrl) {

                    // Provide the callback for loading the grid configuration options
                    options.getTemplate = function (params) {

                        // Call the backend URL for the template
                        $.get({
                            url: templateUrl,
                            data: $.param(_getColumnValuesToPost(agGridApi, renderer.data)),
                            dataType: "text"
                        }
                        ).done(function (results) {

                            // Provide the template to the callback
                            params.successCallback(results);

                        }).fail(function (hxr, status, error) {
                            console.error(error);
                        });
                    };
                }

                // If there is a grid, provide the grid callbacks
                if (gridUrl) {

                    // Provide the callback for loading the grid configuration options
                    options.getGridOptions = function (params) {

                        // Call the backend URL for the grid control, setting the 'gridProperties' header so that we get just the grid settings\properties object
                        $.get({
                            url: gridUrl,
                            data: $.param(_getColumnValuesToPost(agGridApi, renderer.data)),
                            dataType: "text",
                            headers: { [_httpHeaderNames.gridProperties]: "true" },
                        }
                        ).done(function (results) {

                            // Wrap the resulting json-ish text into a javascript variable assingment.  We can't parse it as json b\c there could be
                            // javasript stuff in it, (like Dates, and functions), so we need to execute it, not parse it.
                            var scriptBlock = $("<script>var __gridOptions = " + results + ";</script>");
                            $('body').append(scriptBlock);

                            // When we send in the gridProperties header, the grid doesn't send back any rowData, but rowData has to at least be there and be empty to initialize
                            // the grid properly.
                            __gridOptions.rowData = [];

                            // Provide the grid config
                            params.successCallback(__gridOptions);

                        }).fail(function (hxr, status, error) {
                            console.error(error);
                        });
                    };

                    // Provide the callback for getting the grid data
                    options.getGridRowData = function (params) {

                        _fetchGridRowsFromAjax(gridUrl, $.param(_getColumnValuesToPost(agGridApi, params.data)), gridUpdate => params.successCallback(gridUpdate.rowData));
                    };

                }

                return options;
            }
        }

        // Prepare general defaults of the grid properties
        //
        function _prepareDefaults(gridProperties) {

            var providers = [];

            gridProperties.defaultColDef.cellClass = function (params) {
                var cellClasses = [];

                for (var provider of providers) {
                    var cellClass = provider(params);
                    if (cellClass) {
                        cellClasses.push(cellClass);
                    }
                }

                return cellClasses;
            };

            // Make the providers list accessible to all the consumers that will add to it
            gridProperties.defaultColDef.cellClass.providers = providers;
        }

        //
        // Prepare the exporting values in the gridProperties before its sent to the grid for initialization
        //
        function _prepareExporting(gridProperties) {
            gridProperties.defaultColDef.cellClass.providers.push(function (params) {
                return params.colDef.context["_lrs/_excelCellFormat"];
            });
        }

        //
        // Prepare the editing values in the gridProperties before its sent to the grid for initialization
        //
        function _prepareEditing(gridProperties) {

            if (!gridProperties.context["_lrs/editing"]) {
                return;
            }

            // Turn on editing for all columns by default.  Individual columns will disable as desired
            gridProperties.defaultColDef.editable = true;

            // Initialize each row for editing
            gridProperties.rowData.forEach(function (data) {
                _initializeRowEditingState(data);
            });

            // We use the getRowClass callback to display our row styling
            gridProperties.getRowClass = _onGetInlineEditingRowClass;

            // We use the getCellClass callback for cell styling
            gridProperties.defaultColDef.cellClass.providers.push(_onGetInlineEditingCellClass);

            // Setup our custom editing components
            gridProperties.components = gridProperties.components || {};
            gridProperties.components["CheckBoxCellEditor"] = CheckBoxCellEditor;
            gridProperties.components["SelectCellEditor"] = SelectCellEditor;
            gridProperties.components["DatePickerCellEditor"] = DatePickerCellEditor;
        }

        ///
        /// Initializes the values of a data row for our grid editing.
        ///
        function _initializeRowEditingState(data) {
            data.__original = Object.assign({}, data);
            data.__state = InlineEditingState.original;
            data.__validation = {};
        }

        //
        // Initialize editing functionality if configured
        //
        function _initializeEditing(gridProperties) {

            var agGridApi = gridProperties.agGridApi;
            var gridBody = $(agGridApi.pg.gridBody);

            // Below this point everything is specific to inline editing, which is indicated by the following property
            if (!gridProperties.context["_lrs/editing"]) {
                return;
            }

            // Hook up the clickToStart handlers.  We are doing this ourselves vs. using the grids builtin ability to do
            // so, so that we can prevent editing on "deleted" rows.
            if (gridProperties.context["_lrs/editing/clickToStart"]) {

                var eventName = gridProperties.context["_lrs/editing/clickToStart"] == "double" ? "cellDoubleClicked" : "cellClicked";

                // Add a listener for cell clicks (or double-clicks) to intiate editing
                agGridApi.addEventListener(eventName, function (params) {

                    // Don't initiate the edit if this is a row that's marked for deletion, or if it isn't editable.
                    var uneditable = params.data.__state == InlineEditingState.deleted || !_isColumnEditable(params.column.colDef, params);

                    if (uneditable) {
                        return;
                    }

                    // if the cell is already being edited, don't start editing again
                    if (agGridApi.isEditing({ rowNode: params.node, column: params.Column }))
                    {
                        return;
                    }
                    
                    _inlineEditingBeginEditing(agGridApi, params.rowIndex, params.column);
                });
            }

            // This was added for the ag-grid v33 upgrade.  For some reason the ag row class "ag-row-inline-editing" didn't go away
            // when editing was stopped, so it maintaned an editing look.  Forcing the cells to refresh on the stop event cleared it
            // up, but at some point should look into why this is needed.  It's not needed in the ag-grid demos.
            agGridApi.addEventListener("rowEditingStopped", function (params) {
                agGridApi.refreshCells({ rowNodes: [params.node], force: true });
            });

            // Helper function that indicates if the given element is "within" the grid
            function isWithinGrid(element) {

                // See if the focus is moving to something still within the grid
                var inGrid = $.contains(gridBody[0], element[0]);

                if (!inGrid) {
                    // See if the focus is moving to the bootstrap-picker dropdown div
                    var dropdown = element.closest(".bootstrap-select");

                    // check if the dropdown is associated with element in grid
                    if (dropdown.length) {
                        var assocId = dropdown.find("div[role='listbox']").attr("id");

                        inGrid = gridBody.find("[aria-owns='" + assocId + "']").length === 1;
                    }
                }

                return inGrid;
            }

            // The grid has the option to end editing on loss of focus to the grid, but it doesn't play nice with the dropdown select box b\c 
            // when that pops open it thinks the grid has lost focus.  So we need to manage this feature ourselves.
            gridBody.on("focusout", function (event) {

                // For focusout the related target is where focus is moving to
                var losingFocus = $(event.target);
                var gainingFocus = $(event.relatedTarget);

                // See if its losing from one of our inline editing butons
                var fromInlineEdit = losingFocus.is(".grid-action._edit._inline");

                // If the new focus is not on the grid, end editing.  But not if its the inline editing button that's losing focus, b\c if that's 
                // the case the user just clicked edit.  Then depending on the type of UI in the column initiating editing it may not be able
                // to accept focus right away (like our SELECT dropdown) in which case it looks like focus is going away from the grid - but it isn't - 
                // so we don't want to stop editing.
                if (!fromInlineEdit && !isWithinGrid(gainingFocus)) {

                    // Due to the setTimeout below, it's possible that in this moment the grid is not editing, but that then the body of setTimeout runs
                    // that it has started editing.  This was the case in an issue with TabToAdd - when tabbbing out of the last cell focus was lost, we'd
                    // call this setTimeout, and by the time it was ran the grid was editng the added row, which was then immediately stopped for editing.
                    // This check makes sure we are already actually editing before initating the setTimeout.
                    if (agGridApi.getEditingCells().length > 0) {

                        // As of ag-grid 26.0 not doing this as a POST results in strange DOM manipluation errors down in ag-grid
                        setTimeout(function () {

                            // If by the time this runs we are back focused within the grid, then it must have been a temporary loss of focus that we 
                            // can ignore.  This was the case when tabbing backwards during editing and moving up a row (but not down a row, weird)
                            if (!isWithinGrid($(document.activeElement))) {

                                // "false" means keep the new value (aka save)
                                agGridApi.stopEditing(false);
                            }

                        }, 0);

                    }
                }
            });

            // Edit handler
            gridBody.on("click", ".grid-action._edit._inline", function () {

                // Find the row, and it's ag-grid assigned index, that we are in
                var row = $(this).closest(".ag-row");
                var rowIndex = parseInt(row.attr("row-index"));

                _inlineEditingBeginEditing(agGridApi, rowIndex);
            });

            // Cancel handler
            gridBody.on("click", ".grid-action._cancel._inline", function () {

                // Find the row, and it's ag-grid assigned index, that we are in
                var row = $(this).closest(".ag-row");
                var rowIndex = parseInt(row.attr("row-index"));
                var rowNode = agGridApi.getDisplayedRowAtIndex(rowIndex);
                var rowData = rowNode.data;

                // If this row is in the middle of adding then this was a brand new add that hasn't been saved yet.  So
                // what we need to do is just remove it like it was never there
                if (rowData.__adding) {
                    agGridApi.applyTransaction({
                        remove: [rowData]
                    });
                }
                // Otherwise, cancel editing and revert back to whatever it was before editing was initiated
                else {
                    // "true" means keep the original value (aka cancel)
                    agGridApi.stopEditing(true);
                }

                _inlineEditingRowChanged(agGridApi, rowNode);
            });

            // Save handler
            gridBody.on("click", ".grid-action._save._inline", function () {

                // "false" means keep the new value (aka save)
                agGridApi.stopEditing(false);

            });

            // Delete handler
            gridBody.on("click", ".grid-action._delete._inline", function () {

                // Find the row, and it's ag-grid assigned index, that we are in
                var row = $(this).closest(".ag-row");
                var rowIndex = parseInt(row.attr("row-index"));
                var rowNode = agGridApi.getDisplayedRowAtIndex(rowIndex);
                var rowData = rowNode.data;

                // Mark this row as deleted
                rowData.__state = InlineEditingState.deleted;

                _inlineEditingRowChanged(agGridApi, rowNode);
            });

            // Undo handler
            gridBody.on("click", ".grid-action._undo._inline", function () {

                // Find the row, and it's ag-grid assigned index, that we are in
                var row = $(this).closest(".ag-row");
                var rowIndex = parseInt(row.attr("row-index"));
                var rowNode = agGridApi.getDisplayedRowAtIndex(rowIndex);
                var rowData = rowNode.data;

                // If this row was added, we just remove it completely.
                if (rowData.__state == InlineEditingState.added) {
                    agGridApi.applyTransaction({
                        remove: [rowData]
                    });

                    _inlineEditingRowChanged(agGridApi, rowNode);
                }

                // If it was deleted then we have to figure out if we need to mark it as edited or as original, depending
                // on if there are edits
                else if (rowData.__state == InlineEditingState.deleted) {
                    _onRowInlineEditSaved({ api: agGridApi, data: rowData, node: rowNode });
                }

                // Otherwise restore the original data
                else {
                    Object.assign(rowData, rowData.__original);
                    rowData.__state = InlineEditingState.original;

                    _inlineEditingRowChanged(agGridApi, rowNode);
                }
            });

            // Listen for editing saves
            agGridApi.addEventListener("rowValueChanged", _onRowInlineEditSaved);
            agGridApi.addEventListener("cellValueChanged", _onCellValueChanged);

            // If posting is enabled, hook up the form handler and apply any changes that were posted and now sent back down
            var postToName;
            if ((postToName = agGridApi.pg.gridOptions.context["_lrs/editing/postToName"]) != null) {

                // See if any changes have been sent down from a previous post. We need to "replay" it so the grid looks the same
                // as it did before the post.
                var postedChanges = agGridApi.pg.gridOptions.context["_lrs/editing/postedChanges"];
                if (postedChanges != null) {

                    postedChanges.forEach(function (postedChange) {
                        var state = postedChange.ChangeType;

                        var rowData;
                        var rowNode;

                        if (state != InlineEditingState.added) {

                            // Find the row that goes with this posted change
                            agGridApi.forEachNode(function (node) {
                                if (node.data[_changeIdColumnName] == postedChange.ChangeID) {
                                    rowNode = node;
                                    rowData = rowNode.data;
                                }
                            });
                        }

                        else {

                            var rowData = {};

                        }

                        // "replay" the change so it looks the same as if the user did it
                        _populateRowDataFromPostedChange(agGridApi, postedChange, rowData);
                        rowData.__state = state;
                        rowData.__validation = Object.assign(rowData.__validation || {}, postedChange.ModelErrors);

                        // If node is still, this is an add and we need to create a new row (node)
                        if (rowNode == null) {
                            agGridApi.applyTransaction({
                                add: [rowData]
                            }).add[0];
                        }
                        // Otherwise we just need to refresh the existing one
                        else {
                            // We don't call _inlineEditingRowChanged here b\c that kicks off events to the API.  We are just rehydrating,
                            // the user isn't making new changes.
                            redrawDirtyNodes(agGridApi, [rowNode]);
                        }
                    });
                }

                _attachFormDataHandler(agGridApi,
                    function (formData) {

                        var editedNodes = _getInlineEditedNodes(agGridApi);

                        // Get everything that is edited
                        if (editedNodes.length > 0) {

                            editedNodes.forEach(function (node, index) {

                                var state = node.data.__state;

                                // If the row is being deleted, use its original data.  If there was an edit, then the clicked delete, we don't want to
                                // send along the edits b\c there could be model state errors.  Those errors would be irrelevant since its being
                                // deleted anyway.
                                var rowData = (state == InlineEditingState.deleted) ? node.data.__original : node.data;

                                // Post the type of change it is, and its index is the changeID
                                formData.append(`${postToName}[${index}].ChangeType`, state);
                                formData.append(`${postToName}[${index}].ChangeID`, index);

                                var valuesToPost = _getColumnValuesToPost(agGridApi, rowData);

                                for (var pair of valuesToPost) {

                                    // Add the form data
                                    formData.append(`${postToName}[${index}].GridRow.${pair.name}`, pair.value);
                                }
                            });
                        }

                        // If there is nothing edited, we still want to send the presence indicator so that the binding mechanism knows to clear out
                        // the server side collection of edits.  This is really pretty specific to the wizard which maintains model state accross posts.
                        else {
                            formData.append(postToName, _formFieldPresenceIndicator);
                        }
                    }
                );
            }
        }

        //
        // Get an array of name\value pairs that can be sent as GET params or POST values back to the server
        //
        function _getColumnValuesToPost(agGridApi, rowData) {

            var values = [];

            agGridApi.getColumns().forEach(function (column) {

                // The .net model property that generated this column that we will post back for binding to
                var modelProperty = column.colDef.context["_lrs/property"];

                // The raw value stored in the row data
                var value = rowData[column.colDef.field];

                // Convert dates
                if (value instanceof Date) {

                    // We want to preserve the time as the user sees it, regardless of the user's timezone.  So we convert this 
                    // to a local date, then strip off the "Z".
                    value = new Date(
                        value.getFullYear(),
                        value.getMonth(),
                        value.getDate(),
                        value.getHours(),
                        value.getMinutes() - value.getTimezoneOffset(),
                        value.getSeconds());

                    value = value.toISOString();
                    value = value.replace("Z", "");
                }
                // Special handling for name\value pairs 
                else if (nameValueHelper.isNameValue(value)) {

                    // First add the actual value.  Then we'll set 'value' to be the name, so it gets added second below.  This makes both the value
                    // and the name accessible to model binders that need it (NameValueModelBinder), but is fine for those that don't b\c they
                    // just pull from ValueProviderResult.FirstValue anyway.
                    values.push({ name: modelProperty, value: nameValueHelper.getValue(value) });

                    // Now set the value to name, and it will be the second thing appended for this model property just below
                    value = nameValueHelper.getName(value);
                }
                // Special handling for %.  The model binding for %'s assumes it was entered by a user.  The model binding will
                // try to interpret it as if the user typed it in, so we need to tell (trick) the binding into doing the right thing.
                else if (column.colDef.context["_lrs/valueFormat"] == "percent") {

                    if (Number.isFinite(value)) {

                        // PG supports 7 decimal precision
                        var decimals = 7;
                        var negative = value < 0;
                        if (negative) {
                            value = -value;
                        }

                        // This multiplies by 100 without losing decimal accuracy.
                        value = (Number(Math.round(value + "e" + decimals) + "e-" + (decimals - 2)) * (negative ? -1 : 1)) + "%";
                    }
                }

                // Add this value
                values.push({ name: modelProperty, value: (value !== null && value !== void 0) ? value : "" });

            });

            return values;
        }

        //
        // Delete the form data entry with the given name\value.  We have do it this way because you can't delete a specific
        // name\value pair.  When you .delete() a name, it deletes all entries.  So the only way to delete a specific name value
        // pair is to delete everything, then add back everything except what you want.
        //
        function _deleteFormDataEntry(formData, name, value) {

            // Make a full copy
            var formCopy = [];
            for (const entry of formData) {
                formCopy.push({ name: entry[0], value: entry[1] });
            }

            // Delete all the original
            for (const entry of formCopy) {
                formData.delete(entry.name);
            }

            // Now add back everything that isn't our name\value combination
            for (const entry of formCopy) {
                if (!(entry.name == name && entry.value == value)) {
                    formData.append(entry.name, entry.value);
                }
            }
        }

        //
        // Redraw the given nodes whose data has changed from what the grid is aware of.  The data changes are redrawn by the grid automatically,
        // but we need to call this to force the css class styles to update and the grand totals to update
        //
        function redrawDirtyNodes(agGridApi, nodes) {

            agGridApi.redrawRows({ rowNodes: nodes });

            // Update the grand totals (if any)
            if (agGridApi._updateGrandTotals) {
                agGridApi._updateGrandTotals({ api: agGridApi });
            }

        }

        //
        // Indicates if the given column is editable based on its colDef.editable callback using the given params
        //
        function _isColumnEditable(colDef, params) {

            var editable = colDef.editable;

            if (_.isFunction(editable)) {
                return editable(params);
            }

            return editable == true;
        }

        //
        // Populate the given rowData object with the data from the posted chnage that is being sent back down to us
        //
        function _populateRowDataFromPostedChange(agGridApi, postedChange, rowData) {

            for (const property in postedChange.PostedData) {

                // Find the column(s) who have this property
                var columns = agGridApi.getColumns().filter(column => column.colDef.context["_lrs/property"] == property);

                // Update all fields with the new value
                columns.forEach(column => {

                    var value = postedChange.PostedData[property];

                    // Special case for dates, need to change them from strings to actual dates
                    if (typeof value === "string" && dateFormat.test(value)) {
                        value = new Date(value);
                    }

                    // Special case for %, we format the value before sending it to the server so the server knows exactly how
                    // to interpret it as a %.  Because of this, we need to reparse it as it comes back down.
                    if (column.colDef.context["_lrs/valueFormat"] == "percent" && typeof value === "string") {
                        value = rs.module("controls/framework/ag/agValueParsing").parse(value, { name: "percent" }, { column });
                    }

                    // If it is a numeric but the value that came down is an empty string, assume that is probably actually null.
                    if (column.colDef.context["_lrs/isNumeric"] && value === "") {
                        value = null;
                    }

                    rowData[column.colDef.field] = value;
                });
            };
        }

        //
        // Begin inline editing on the row with the given index
        //
        function _inlineEditingBeginEditing(agGridApi, rowIndex, targetColumn) {

            // Either start editing on the target column, or on the first one to its right that is in fact editable depending on requested behavior
            var columnToEdit = (targetColumn == null) ? _getFirstEditableColumn(agGridApi, rowIndex) : targetColumn;

            // Start editing
            agGridApi.startEditingCell({
                rowIndex: rowIndex,
                colKey: columnToEdit.getId(),
            });
        }

        //
        // From the visible columns left-to-right, get the first editable column starting with the given column (which can be null to start at the beginning)
        //
        function _getFirstEditableColumn(agGridApi, rowIndex, fromRight, startFrom, nullIfNone) {

            var node = agGridApi.getDisplayedRowAtIndex(rowIndex);

            // We have to fake a "params" object that the editable callback needs to determine editability
            function createParams(colDef) {
                return {
                    node,
                    data: node.data,
                    value: node.data[colDef.field],
                    rowIndex,
                    colDef
                };
            }

            var columns = agGridApi.getAllDisplayedColumns();

            // Find first editable column
            var columnToEdit = startFrom ? startFrom : columns[fromRight ? columns.length - 1 : 0];
            while (columnToEdit != null && !_isColumnEditable(columnToEdit.colDef, createParams(columnToEdit.colDef))) {
                columnToEdit = fromRight ? agGridApi.getDisplayedColBefore(columnToEdit) : agGridApi.getDisplayedColAfter(columnToEdit);
            }

            // If for some reason there are no editable columns visible in the grid, use the first
            return (columnToEdit || nullIfNone) ? columnToEdit : columns[fromRight ? columns.length - 1 : 0];
        }

        //
        // Get the next editable cell starting with the given cell.  If the given cell is editable, it is returned
        //
        function _getNextEditableCell(agGridApi, startCell, backwards) {

            // If we are in the grand totals row, there's no editable cell here
            if (startCell.rowPinned == "bottom") {
                return null;
            }

            // Get the next editable cell in the current row
            var rowIndex = startCell.rowIndex;
            var column = _getFirstEditableColumn(agGridApi, rowIndex, backwards, startCell.column, true);

            // If there wasn't one, we need to go to the next row
            if (!column) {

                rowIndex = backwards ? rowIndex - 1 : rowIndex + 1;

                // Out of rows
                if (rowIndex < 0 || rowIndex > (agGridApi.getDisplayedRowCount() - 1)) {
                    return null;
                }

                // Get the first editable column in this new row
                column = _getFirstEditableColumn(agGridApi, rowIndex, backwards, null, true);

                // Should definitely be one or we wouldn't be editable in the first place, but check anyway
                if (!column) {
                    return null;
                }
            }

            return {
                rowIndex: rowIndex,
                column: column
            };
        }

        //
        // Function called by the grid when the user commits changes after inline editing a row
        //
        function _onRowInlineEditSaved(event) {

            var agGridApi = event.api;
            var rowData = event.data;

            // If it has an original, it's an edit. Otherwise it must be an add
            if (rowData.__original) {
                rowData.__state = _isRowEqual(agGridApi, rowData, rowData.__original) ? InlineEditingState.original : InlineEditingState.edited;
            } else {
                rowData.__state = InlineEditingState.added;
            }

            _inlineEditingRowChanged(agGridApi, event.node);
        }

        //
        // Function called by the grid when an individual cell value has changed
        //
        function _onCellValueChanged(event) {
            // When the value changes reset the validation state
            event.data.__validation[event.colDef.context["_lrs/property"]] = null;
        }

        //
        // Adds a new row to the grid and initiates editing on it.  If 'defaults' is provided it is used as the
        // default data for the row.
        //
        function _onInlineEditingAddRow(defaults, commitImmediately) {
            var agGridApi = this;
            var gridProperties = agGridApi.pg.gridOptions;

            if (!gridProperties.context["_lrs/editing"]) {
                throw new Error("Cannot add a row for inline editing when inline editing has not been enabled for the grid.");
            }

            // The razor-assigned defaults (if any) get overrwitten by the supplied defaults (if any) on a property-by-property basis.
            var effectiveDefaults = Object.assign({}, (gridProperties.context["_lrs/editing/newRowDefaults"] || {}), (defaults || {}));

            // Add the row
            var result = agGridApi.applyTransaction({
                add: [effectiveDefaults]
            });

            var added = result.add[0];
            added.data.__validation = {};
            added.data.__state = InlineEditingState.added;
            added.data.__adding = true;

            // If the row isn't supposed to be in an immediately commited state, initiate editing
            if (!commitImmediately) {
                // Post this so it doesn't happen within a button click handler (if for example this is being called in response to the user clicking some external
                // button).  If we didn't do this then the button click event would end up finishing firing after we started editing, which would be seen as the user
                // clicking outside of the grid, and terminate editing.
                setTimeout(function () {
                    _inlineEditingBeginEditing(agGridApi, added.rowIndex);
                }, 0);
            }
            else {
                // Simulate the saved event
                _onRowInlineEditSaved({ api: agGridApi, node: added, data: added.data });
            }

            return added;
        }

        //
        // Called when a row has been changed via inline editing, after all the data and state has been applied.  This
        // gets called for all changes - edits, deletes, and adds
        //
        function _inlineEditingRowChanged(agGridApi, rowNode) {

            // If this was a row in the middle of being added, clear that now
            rowNode.data.__adding = undefined;

            if (agGridApi.inlineEditingRowChangedCallback) {

                // Create the change object that will be the argument
                var change = _createInlineEditingChangeInstance(agGridApi, rowNode);

                agGridApi.inlineEditingRowChangedCallback(change);
            }

            redrawDirtyNodes(agGridApi, [rowNode]);
        }

        //
        // Create a 'change' instance from the given rowNode that represents the current inline editing change state for the row.
        //
        function _createInlineEditingChangeInstance(agGridApi, rowNode) {

            var rowData = rowNode.data;

            // Create the change object
            var change = {

                // new and old data (depending on state)
                newData: (rowData.__state != InlineEditingState.deleted && rowData.__state != InlineEditingState.original) ? rowData : null,
                oldData: (rowData.__state != InlineEditingState.added) ? rowData.__original : null,

                // Helper methods to accept or reject the change immediately
                accept: function accept() { _inlineEditingAcceptChanges(agGridApi, [rowNode]); },
                reject: function reject() { _inlineEditingRejectChanges(agGridApi, [rowNode]); },

                // grid node
                node: rowNode,
            };

            // Utility state methods
            Object.defineProperty(change, 'edited', { get: function () { return rowData.__state == InlineEditingState.edited; } });
            Object.defineProperty(change, 'added', { get: function () { return rowData.__state == InlineEditingState.added; } });
            Object.defineProperty(change, 'deleted', { get: function () { return rowData.__state == InlineEditingState.deleted; } });
            Object.defineProperty(change, 'original', { get: function () { return rowData.__state == InlineEditingState.original; } });

            return change;
        }

        //
        // Marks all the pending inline editing changes as accepted.  'nodes' can be null to accept all, or an
        // array of row nodes to accept specific changes
        //
        function _inlineEditingAcceptChanges(agGridApi, nodes) {

            if (!nodes) {
                nodes = _getInlineEditedNodes(agGridApi);
            }

            for (var node of nodes) {
                switch (node.data.__state) {
                    case InlineEditingState.edited:
                    case InlineEditingState.added:
                        {
                            node.data.__original = Object.assign({}, node.data);
                            node.data.__state = InlineEditingState.original;
                            node.data.__validation = {};
                        }
                        break;
                    case InlineEditingState.deleted:
                        {
                            agGridApi.applyTransaction({
                                remove: [node.data]
                            });
                        }
                        break;
                }
            }

            // Redraw all the rows, except the ones that had been deleted, becuase they gone now
            redrawDirtyNodes(agGridApi, nodes.filter(node => node.data.__state != InlineEditingState.deleted));
        }

        //
        // Marks all the pending inline editing changes as rejected, and rolls back to the original data. 'nodes' can be null to accept all, or an
        // array of row nodes to accept specific changes
        //
        function _inlineEditingRejectChanges(agGridApi, nodes) {
            if (!nodes) {
                nodes = _getInlineEditedNodes(agGridApi);
            }

            for (var node of nodes) {

                switch (node.data.__state) {
                    case InlineEditingState.edited:
                    case InlineEditingState.deleted:
                        {
                            Object.assign(node.data, node.data.__original);
                            node.data.__state = InlineEditingState.original;
                            node.data.__validation = {};
                        }
                        break;
                    case InlineEditingState.added:
                        {
                            agGridApi.applyTransaction({
                                remove: [node.data]
                            });
                        }
                        break;
                }

                _inlineEditingRowChanged(agGridApi, node);
            }
        }

        //
        // Returns all the nodes in the grid that have been inline edited in some way
        //
        function _getInlineEditedNodes(agGridApi) {
            var nodes = [];
            agGridApi.forEachNode(function (node) {
                if (!node.group && node.data.__state != InlineEditingState.original) {
                    nodes.push(node);
                }
            });

            return nodes;
        }

        //
        // Called back by the grid to get the row css class to be used for a given row
        //
        function _onGetInlineEditingRowClass(params) {
            var rowData = params.data;

            // If this is a grandTotals row, then there is no state to show
            if (params.node.rowPinned == "bottom") {
                return "";
            }

            switch (rowData.__state) {
                case InlineEditingState.edited: return "_edited";
                case InlineEditingState.added: return "_added";
                case InlineEditingState.deleted: return "_deleted";
            }
        }

        //
        // Called back by the grid to get the cell css class to be used for a given row
        //
        function _onGetInlineEditingCellClass(params) {
            var colDef = params.colDef;
            var rowNode = params.node;
            var rowData = rowNode.data;

            var cssClass = "";


            // If this is a grandTotals row, then we don't try to validate it.
            if (rowNode.rowPinned == "bottom") {
                return cssClass;
            }

            // Edit hover indicators (not using pg.gridOptions b\c this can get called prior to that being ready)
            var clickToStart = _gridOptions(params.api).context["_lrs/editing/clickToStart"];
            if (_isColumnEditable(colDef, params) && clickToStart && rowData.__state != InlineEditingState.deleted) {
                cssClass += " _editable";

                var singleClickEditing = (clickToStart == "single");
                if (singleClickEditing) {
                    cssClass += " _single";
                }
            }

            // Edit modifications
            if (rowData.__state == InlineEditingState.edited) {
                if (!_isColumnValueEqual(colDef.field, rowData, rowData.__original)) {
                    cssClass += " _modified";
                }
            }

            // Validation errors.  Don't show validation errors for non-editable columns - there's nothing the user could do.
            if (_isColumnEditable(colDef, params) && (rowData.__state == InlineEditingState.edited || rowData.__state == InlineEditingState.added)) {

                if (rowData.__validation[colDef.context["_lrs/property"]] != null) {
                    cssClass += " _invalid";
                }
            }

            return cssClass;
        }

        //
        // Indicates if the two rows are equal for each of the column values
        //
        function _isRowEqual(agGridApi, rowLeft, rowRight) {

            for (var column of agGridApi.getColumns()) {

                if (!_isColumnValueEqual(column.colDef.field, rowLeft, rowRight)) {
                    return false;
                }
            }

            return true;
        }

        //
        // Indicates if the column value given by column 'field' is the same for each of the given rows.
        //
        function _isColumnValueEqual(field, rowLeft, rowRight) {

            var valueLeft = rowLeft[field];
            var valueRight = rowRight[field];

            // Dates
            if (valueLeft instanceof Date && valueRight instanceof Date) {
                valueLeft = valueLeft.getTime();
                valueRight = valueRight.getTime();
            }

            // Name values
            else if (nameValueHelper.isNameValue(valueLeft) && nameValueHelper.isNameValue(valueRight)) {
                valueLeft = nameValueHelper.getValue(valueLeft);
                valueRight = nameValueHelper.getValue(valueRight);
            }

            return (valueLeft == valueRight);
        }

        //
        // Update the grid with the json data returned from the given url
        // options.appendAsPending = append rows in an added state
        //
        function update(ajaxUrl, ajaxData, agGridApi, done, options) {

            options = _.extend({ appendAsPending: false }, options);

            return _fetchGridRowsFromAjax(ajaxUrl, ajaxData, gridUpdate => {

                // If a context was sent down in the response, assign all of it's properties in.  There shouldn't be any of our custom data properties using attributes,
                // it should only be properties that were specifically created using Builder context methods.
                if (gridUpdate.context) {
                    Object.assign(agGridApi.pg.gridOptions.context, gridUpdate.context);
                }

                if (options.appendAsPending) {

                    gridUpdate.rowData.forEach((pendingRow) => {

                        // Add the row
                        var node = _onInlineEditingAddRow.call(agGridApi, pendingRow, true);

                        // See if it needs selected
                        node.setSelected(node.data[_selectedColumnName] === true);
                    });

                } else {

                    // Prepare each new row for grid editing, if we're in an editable grid
                    if (agGridApi.pg.gridOptions.context["_lrs/editing"]) {
                        gridUpdate.rowData.forEach(function (data) {
                            _initializeRowEditingState(data);
                        });
                    }

                    // Replace all our rows with the new rows, preserving the filtering state
                    _updateRowDataPreservingFilter(agGridApi, gridUpdate.rowData);

                    // Select any marked as needing selected
                    _selectRowsMarkedForSelection(agGridApi);
                }

                // Update all the exact fit columns (if any) - even if "continuous" is not set.  We know we have new data now, so we may as well update the 
                // column sizing.  Not a perf problem to do it one-time in response to an ajax response.
                if (agGridApi._exactFitColumnSizer) {
                    agGridApi._exactFitColumnSizer(false);
                }

                // Call the user provided completion callback
                done(gridUpdate);
            });
        };

        //
        // Preserve grid filters while setting new rowData
        // Update grand totals if applicable 
        //
        function _updateRowDataPreservingFilter(agGridApi, rowData) {
            // setRowData wipes any filters - save them so we can restore them right after
            var filterState = agGridApi.getFilterModel();

            // null means no rows, but ag-grid needs an empty array in that case
            rowData = rowData || [];

            // Set the new row data
            agGridApi.updateGridOptions({ rowData });
            
            // Put the filters back
            agGridApi.setFilterModel(filterState);

            // Update the grand totals (if any)
            if (agGridApi._updateGrandTotals) {
                agGridApi._updateGrandTotals({ api: agGridApi });
            }
        }

        //
        // Fetch grid rows via ajax, and call the given callback with the row array when done
        //
        function _fetchGridRowsFromAjax(ajaxUrl, ajaxData, callback) {

            return $.get({
                url: ajaxUrl,
                data: ajaxData,

                // Force the callback function to give us the text and not try to pre-parse the JSON.  We need to do
                // the parsing ourselves
                dataType: "text",

                headers: { [_httpHeaderNames.gridUpdate]: "true" },

                success: function (gridJson) {

                    // Parse the JSON, replacing string dates with actual JavaScript dates
                    var gridUpdate = JSON.parse(gridJson, function reviver(key, value) {
                        return (typeof value === "string" && dateFormat.test(value)) ? new Date(value) : value;
                    });

                    callback(gridUpdate);
                },
            }).fail(function (hxr, status, error) {
                console.error(error);
            });
        }

        //
        // ag-grid valueGetter for getting the name of a name\value for display\filtering from the underlying row data.
        //
        function getNameValueName(params) {

            var value = params.data[params.colDef.field];

            // If it is name\value data, use the name
            return nameValueHelper.isNameValue(value) ? nameValueHelper.getName(value) : null;
        }

        //
        // ag-grid filterValueGetter for getting the raw value as a percentage value (multiply by 100)
        //
        function getValueAsPercent(params) {

            var value = params.data[params.colDef.field];

            if (isNaN(value)) {
                return value;
            }

            return value * 100;
        }

        //
        // ag-grid filterValueGetter for getting just the date part of a date object, locked to midnight
        //
        function getDateAtMidnight(params) {

            var date = params.data[params.colDef.field];

            function isValidDate(date) {
                return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
            }

            if (isValidDate(date)) {
                return new Date(date.toDateString());
            }

            return date;
        }

        //
        // Process cell values as they are being exported to csv\excel
        //
        function processExportCellValue(params) {

            var value = params.value;
            var colDef = params.column.colDef;

            // If we are exporting this as a date\time, it has to be in ISO format
            if (colDef.context["_lrs/valueFormat"] == "date" && value) {
                return $.format.date(value, "yyyy-MM-ddTHH:mm:ss.SSS");
            }

            // See if there is a cellRenderer that is creating the value that is displayed.  We want to export that, not the
            // underlying raw value of the column.  This is especially true for any of our template columns.
            if (colDef.cellRenderer != null && colDef.cellRenderer instanceof Function && !colDef.context["_lrs/dontUseCellRenderer"]) {

                // We need to execute the columns custom cell renderer ourself, to get the content as the user sees it
                var html = colDef.cellRenderer({
                    value,
                    data: params.node.data,
                    node: params.node,
                    rowIndex: params.node.rowIndex,
                    colDef,
                    column: params.column,
                    api: params.api,
                    context: params.context
                });

                // It's possible there is no html in the result, but we are about to ask jquery to load it as html, so make sure
                // there's some html or jquery gets angry
                html = "<div>" + html + "</div>"

                var text =

                    // Strip all html,
                    $(html.replace(/<br[^>]*>/gi, "\n"))
                    .text()

                    //convert linebreaks to newlines
                    .split(/\n/)

                    //trim each line
                    .reduce((accumlated, current, index) =>
                        accumlated + (index != 0 ? "\n" : "") + current.trim(), "")

                    // Swap bullets for asterisks, they just look better in the spreadsheet
                    .replaceAll("●", "*")

                    // and reduce multi-spaces within each line to a single space
                    .replace(/\s\s+/g, ' ');

                return text;
            }

            // If it is name\value data, use the name
            if (nameValueHelper.isNameValue(value)) {
                return nameValueHelper.getName(value);
            }

            // Return as is
            return value;
        }

        //
        // Process cell values as they are being copied
        //
        function processCopyCellValue(params) {

            // If this is a masked cell, see if its unmasked, and use that
            var renderParams = params.column.colDef.cellRendererParams;
            if (renderParams != null && renderParams["lrs/masked"]) {

                var gridBody = $(params.api.pg.gridBody);
                var unmaskedCell = gridBody.find(`div[row-id='${params.node.id}'] div[col-id='${params.column.colId}'] .${_maskedDataUnmaskedCssClass}`);

                // If this is a temporarily unmasked cell, give them the unmasked value
                if (unmaskedCell.length == 1) {
                    return unmaskedCell.text();
                }
            }

            // If it is name\value data, use the name
            if (nameValueHelper.isNameValue(params.value)) {

                return nameValueHelper.getName(params.value);
            }

            return params.value;
        }

        //
        // A column callback function that returns the tooltip value reporting any model errors for the column/cell being rendered
        //
        function modelErrorTooltip(params) {
            if (params.location != 'cell') {
                return;
            }

            // If we have __validation property, we can use it for modelstate errors
            if (params.data.__validation) {
                var message = params.data.__validation[params.column.colId];
                if (message) {
                    return message;
                }
            }

            // Otherwise find this row's change id in teh postedChanges collection, and locate the message that way
            if (params.data.__cid !== undefined) {

                var postedChanges = params.api.pg.gridOptions.context["_lrs/editing/postedChanges"];
                var thisChange = postedChanges.find(function (change) {
                    return change.ChangeID == params.data.__cid;
                });

                if (thisChange) {
                    var modelProperty = params.colDef.context["_lrs/property"];
                    return thisChange.ModelErrors[modelProperty];
                }
            }

            return null;
        }

        //
        // Calculate the grand totals data to display in the grand totals row
        //
        function _calculateGrandTotals(agGridApi, grandTotalsOptions) {

            var totalsRow = null;

            // Only create the totals row if 
            if (agGridApi.getDisplayedRowCount() > 0) {

                totalsRow = {};

                // Set the overrides
                var overrides = grandTotalsOptions.overrides;
                for (var columnField in overrides) {
                    totalsRow[columnField] = overrides[columnField];
                }

                var totalsPrecision = {};

                // Go through all the rows to calculate totals
                agGridApi.forEachNodeAfterFilter(function (node, index) {

                    // Only process our actual data nodes, not the automaticaly grouped grid rows, and don't count
                    // "deleted" rows.
                    if (!node.group && node.data.__state != InlineEditingState.deleted) {

                        for (var columnField in node.data) {

                            // If its overridden, ignore it
                            if (!overrides.hasOwnProperty(columnField)) {

                                var value = node.data[columnField];
                                if (value != null && $.isNumeric(value)) {
                                    var valuePrecision = 0;
                                    if (value.toString().includes('.')) {
                                        valuePrecision = value.toString().split('.')[1].length;
                                    }
                                    if (!totalsPrecision[columnField] || totalsPrecision[columnField] < valuePrecision) {
                                        totalsPrecision[columnField] = valuePrecision;
                                    }

                                    totalsRow[columnField] = parseFloat(((totalsRow[columnField] || 0) + (value * 1)).toFixed(totalsPrecision[columnField]));
                                }
                            }
                        }
                    }
                });
            }
            
            // ag-grid wants an array of pinned rows since they allow more than one
            agGridApi.updateGridOptions({ pinnedBottomRowData: totalsRow != null ? [totalsRow] : [] })
        }

        //
        // Gets the columnId of a column (useful for map)
        //
        function _getColumnID(column) {
            return column.getId();
        }

        //
        // Listen for anything that could change the data in the cells.  We listen for model updates (ajax data loaded) and for new row nodes
        // to be inserted into the DOM (existing data that the grid is materializing on the fly as apart of its row virtualization)
        //
        function _listenForCellDataChanges(agGridApi, callback) {

            // Update anytime the model changes...
            agGridApi.addEventListener("modelUpdated", callback);

            // .. and update anytime new rows get created by the grid due to virtualization.
            _listenForCreatedRowNodes(agGridApi, callback);
        }

        //
        // The grid virtualizes rows, so a row that may seem to be in the grid at all times can sometimes actually be deleted and added
        // to the dom as it goes in and out of view.  This registers a callback to receive notice anytime rows are added (back) to the dom.
        //
        function _listenForCreatedRowNodes(agGridApi, callback) {

            // If we haven't setup our notifier system yet...
            if (!agGridApi.addedDomRowNodeNotifier) {

                // This holds the set of all 'callback' functions this function has been called with
                var listeners = new Set();

                // This is the set of events (one per row) that have occurred since the last time a notification was sent out
                var events = [];

                // The notification function that gets invoked to tell all the listeners about the events that have happened
                function notifier() {

                    // We don't invoke syncronously, that can unnecessarily goof up the grid if we try to do work while its
                    // in the middle of its work
                    setTimeout(function () {

                        // It's possible by the time we get here another queued setTimeout has already cleared the event list
                        if (events.length > 0) {

                            // Tell all the listeners (giving them each a new copy of the events), and then reset the event list
                            listeners.forEach((listener) => listener(events.slice()));
                            events.length = 0;

                        }
                    });
                };

                // The notifier function is actually a throttled version of our notifier
                agGridApi.addedDomRowNodeNotifier = _.throttle(notifier, 50);

                // Stuff the listeners and events list as properties of our function for easy access
                agGridApi.addedDomRowNodeNotifier.listeners = listeners;
                agGridApi.addedDomRowNodeNotifier.events = events;
            }

            // Add this callback as a listener
            agGridApi.addedDomRowNodeNotifier.listeners.add(callback);
        }

        //
        // Called by the grid anytime a new row node is created and added to the dom.  This can happen all the time, and happen multiple times
        // for the "same" row due to virtualization
        //
        function _onProcessPostRowCreate(params) {

            var agGridApi = params.api;

            // If anyone has registered to listen...
            if (agGridApi.addedDomRowNodeNotifier) {

                // Add the event to our list, and then invoke the notifier (which is actually throttled)
                agGridApi.addedDomRowNodeNotifier.events.push(params);
                agGridApi.addedDomRowNodeNotifier();
            }
        }

        //
        // Size any columns that are configured to be an exact fit
        //
        function _sizeExactFitColumns(gridProperties) {

            var agGridApi = gridProperties.agGridApi;

            var exactFitColumns = agGridApi.getAllGridColumns().filter(function (column) { return column.colDef.context && column.colDef.context["_lrs/exactfit"]; });

            // No need to do anything if there aren't any exactFitColumns to exactly size
            if (exactFitColumns.length > 0) {

                var sizes = exactFitColumns.map(function (column) { return 0; });
                var exactFitColumnIDs = exactFitColumns.map(_getColumnID);

                var continuousFitColumns = exactFitColumns.filter(function (column) { return column.colDef.context["_lrs/exactfit"] == "continuous"; });
                var continuousFitColumnIDs = continuousFitColumns.map(_getColumnID);

                // The sizing function that will be called from time-to-time
                function exactFitColumnSizer(continuousOnly) {

                    var columnsToUse = continuousOnly ? continuousFitColumns : exactFitColumns;
                    var columnIDsToUse = continuousOnly ? continuousFitColumnIDs : exactFitColumnIDs;

                    // Have the grid perfectly size our exact-fit exactFitColumns
                    agGridApi.autoSizeColumns(columnIDsToUse, false);

                    // Go through each column that was sized and make some updates if necessary
                    columnsToUse.forEach(function (column, index) {

                        // If this is continuous, or we aren't restricted to continuous only
                        if (!continuousOnly || column.colDef.context["_lrs/exactfit"] == "continuous") {

                            // The grids auto sizing gives exactFitColumns more space than they need... this dial's it back to what looks right. 
                            var desiredWidth = column.actualWidth - 16;
                            var previousWidth = sizes[index];

                            // We also make sure here that they never get smaller - only larger. Once we know they need a certain amount of space,
                            // there's really no need to dial it back.
                            if (desiredWidth > previousWidth) {
                                sizes[index] = desiredWidth;
                                agGridApi.setColumnWidths([{ key: column, newWidth: desiredWidth }]);
                            }
                            else {
                                agGridApi.setColumnWidths([{ key: column, newWidth: previousWidth }]);
                            }
                        }
                    });
                }

                // Save it for later, will be used outside of this
                agGridApi._exactFitColumnSizer = exactFitColumnSizer;

                // Size them now (to make it look as right as possible as soon as possible), and also queue up for one more after the grid loads to catch any changes\shifts the grid
                // does during init
                exactFitColumnSizer(false);
                setTimeout(function () { exactFitColumnSizer(false); }, 0);

                // And listen for any changes\updates the data in the cells, which will affect the sizing.  We only need to do this if there
                // are any set to be continuously monitored
                if (continuousFitColumns.length > 0) {

                    _listenForCellDataChanges(agGridApi, function () { exactFitColumnSizer(true); });
                }
            }
        }

        //
        // Initializes the grid column sizing system
        //
        function _initializeColumnSizing(gridProperties, gridDiv, options) {

            var agGridApi = gridProperties.agGridApi;

            // Size any columns that are set to be an exact fit
            _sizeExactFitColumns(gridProperties)

            // We also have to redo the exact fit columns any time the grid becomes visible (or re-visible), otherwise if it is
            // initially hidden then the exact fitting won't work since the grid doesn't have size yet, and would never try to do 
            // it again
            new IntersectionObserver((entries, _) => {

                    var gridMadeVisible = entries.some((entry) => entry.intersectionRatio > 0);

                    // The grid has been made visible
                    if (gridMadeVisible) {

                        // Little helper wrapper since we are going to execute this stuff twice
                        function updateSizingOnVisible() {
                            updateAndRunAutoSizing();

                            // Also do the exact-fit stuff if there is any
                            if (agGridApi._exactFitColumnSizer) {
                                agGridApi._exactFitColumnSizer(false);
                            }
                        }

                        // First time - 10ms delay.  If we don't do this, then on some grids we get scrollbar flickering.  Why does this work? Only God may know, and possible not even.
                        setTimeout(updateSizingOnVisible, 10);

                        // Second time - longer delay.  If we don't do this, there are some cases where a horizontal scrollbar is unnecessarily left showing.  Why? Who TF knows.  Does ag-grid know? Zero chance.
                        setTimeout(updateSizingOnVisible, 50);
                    }
                },

                // We want to know if it becomes visible anywhere within the document
                { root: document.documentElement, })

                // And the gridDiv is our element of interest
                .observe(gridDiv[0]);

            // If not configured to do any auto sizing, get out now
            if (!options) {
                return;
            }

            // Get all the columns that will be participating in autosizing
            var columnsToAutoSize = agGridApi.getAllGridColumns().filter(function (column) {
                return column.colDef.resizable !== false && !column.colDef.flex && !column.colDef.width && column.colDef.context && !column.colDef.context["_lrs/exactfit"];
            });

            // Do the autosizing and minimum storing
            autoSizeAndUpdateMinimums(columnsToAutoSize);

            // Whenever cell data changes we need to make sure our minimums are properly up to date
            if (options.strategy == "content") {
                _listenForCellDataChanges(agGridApi, updateAndRunAutoSizing);
            }

            // Size the columns to fit the grid now
            doColumnSizing();

            // Function to autosize all the given columns and update their stored minimums to match the sizes
            function autoSizeAndUpdateMinimums(columns) {

                // Autosize them to exactly fit their content.
                agGridApi.autoSizeColumns(columns.map(_getColumnID), false);

                // Setup some data we are going to store for each column to track which ones are still being autosized (hasn't
                // been overridden by user resizing) and what the minimums are
                columns.forEach(function (column) {
                    column._autoSize = {
                        minimum: (options.strategy == "content") ? column.actualWidth : 0
                    };
                });
            }

            // Our own little enhanced version of sizing all columns to fit into the grid
            function doColumnSizing(event) {

                // This check prevents flashing that was occuring when the browser zoom was reduced below 90%
                if (event && event.type == "gridSizeChanged") {

                    if (event.clientWidth == agGridApi.pg._lastClientWidth) {

                        // We aren't going to do any width sizing, but we do need to make sure the vertical scrollbar gets updated
                        // in case we had forced it off and now the height has shrunk to where we need it.  If doing this causes
                        // a change, then we do not escape out because that change might cause a need to rework the column widths
                        if (!updateScrollbarVisibility(agGridApi)) {
                            return;
                        }
                    }

                    agGridApi.pg._lastClientWidth = event.clientWidth;
                }

                // Stop listening
                registerSizingEvents(false);

                // The columns to autosize here are the ones with _autoSize set.  We temporarily turn on 'suppressSizeToFit' for any columns
                // not participating in autosizing, and also set all the minWidths of those that are so they can't be shrunk down past their
                // minimum content size.
                agGridApi.getAllGridColumns().forEach(function (column) {
                    // If not eligible for autosize, then we have to make sure it doesn't get sized to fit
                    if (!column._autoSize) {
                        column._originalSuppressSizeToFit = column.colDef.suppressSizeToFit;
                        column.colDef.suppressSizeToFit = true;
                    }
                    // Otherwise, make sure it can't get smaller than it is configured to be
                    else {
                        column._originalMinWidth = column.minWidth;
                        column.minWidth = column._autoSize.minimum;
                    }
                });

                // Then go ahead and size them to fit within the grid, which does the sizing to fit proportional to the current width of the columns.
                if (_isGridVisible(agGridApi)) {
                    agGridApi.sizeColumnsToFit();
                }

                // Put the original properties back
                agGridApi.getAllGridColumns().forEach(function (column) {
                    if (!column._autoSize) {
                        column.colDef.suppressSizeToFit = column._originalSuppressSizeToFit;
                    }
                    else {
                        column.minWidth = column._originalMinWidth;
                    }
                });

                // Start listening again
                registerSizingEvents(true);

                // Update the scrollbar visibility
                if (updateScrollbarVisibility(agGridApi)) {

                    // If we changed scrollbar visibility, then the available space in the grid has changed, and we need to reflow 
                    // the column sizing again.
                    setTimeout(doColumnSizing);
                }
            }

            // Update all autosizing minimums and execute the resizing.  This is done in response to data or visibility changes
            function updateAndRunAutoSizing() {

                // Stop listening
                registerSizingEvents(false);

                // Get all the columns that are participating in autosizing, and capture their current sizes
                var columnsToUpdate = agGridApi.getAllGridColumns().filter((column) => column._autoSize);

                // Autosize the columns and update with their new minimums
                autoSizeAndUpdateMinimums(columnsToUpdate);

                // Start listening again
                registerSizingEvents(true);

                // Now update all the sizing with the new minimums in place
                doColumnSizing();
            }

            // When a user manually resizes a column, it is no longer eligible for autosizing
            function clearAutoSizing(event) {

                // Only watch for user manually doing this
                if (event.source == "uiColumnResized") {
                    event.columns.forEach(column => column._autoSize = null);
                }
            }

            // Register (or unregister) all the sizing events
            function registerSizingEvents(register) {

                // Helper to register or unregister the given callback
                function registerOrUnregister(name, callback) {
                    if (register)
                        agGridApi.addEventListener(name, callback);
                    else
                        agGridApi.removeEventListener(name, callback);
                }

                // Events to listen to to monitor column\grid sizing changes
                var eventsRequiringColumnSizing = ["gridSizeChanged", "columnResized", "columnVisible", "columnPinned"];

                // First register the column resize event that will clear any autosizing when a user manually sizes a column
                registerOrUnregister("columnResized", clearAutoSizing);

                // Then register to update all the column sizes on each event we are watching
                eventsRequiringColumnSizing.forEach(function (name) {
                    registerOrUnregister(name, doColumnSizing);
               });
            }
        }

        // Even when doing autofit we may need the scrollbar if the grid gets too small to fit the columns in their smallest state
        function updateScrollbarVisibility(agGridApi) {

            // Capture the current state
            var wasHScrollHidden = $(agGridApi.pg.gridHorizontalScroll).hasClass("d-none");
            var wasVScrollHidden = $(agGridApi.pg.gridVerticalScroll).hasClass("d-none");

            // Turn off/on the horizontal bar based on if they fit
            var horizontalFit = _doColumnsFitWithinGrid(agGridApi);
            $(agGridApi.pg.gridHorizontalScroll).toggleClass("d-none", horizontalFit);

            // If we don't need the vertical scrollbar, force it off.  Ag-grid is an idiot sometimes and will show it when it isn't needed and leads to flashing.
            var verticalFit = _doRowsFitWithinGrid(agGridApi);
            $(agGridApi.pg.gridVerticalScroll).toggleClass("d-none", verticalFit);

            // If there was a vertical fit, so we turned off the vertical, recheck to see if there's now space for the horizontal
            if (verticalFit && !horizontalFit) {

                // Turn off/on the horizontal bar based on if they now fit
                $(agGridApi.pg.gridHorizontalScroll).toggleClass("d-none", _doColumnsFitWithinGrid(agGridApi));
            }

            // Capture the updated state
            var isHScrollHidden = $(agGridApi.pg.gridHorizontalScroll).hasClass("d-none");
            var isVScrollHidden = $(agGridApi.pg.gridVerticalScroll).hasClass("d-none");

            // We return true if anything changed
            return wasHScrollHidden != isHScrollHidden || wasVScrollHidden != isVScrollHidden;
        }

        //
        // Indicates if the current set of visible columns fully fit within the grid width without needing a scrollbar
        //
        function _doColumnsFitWithinGrid(agGridApi) {

            // Get the "main" columns, (those that aren't pinned, or as ag calls them, "center")
            var mainColumns = agGridApi.getDisplayedCenterColumns();

            // If there are no main columns, then the main columns surely fit..
            if (mainColumns.length == 0) {
                return true;
            }

            var lastMainColumn = mainColumns[mainColumns.length - 1];
            var lastMainRight = lastMainColumn.actualWidth + lastMainColumn.left;

            // Now figure out how much space the main columns have.  Which is the container width, minus the space used by the columns that are pinned.
            // We can't use offsetWidth b\c its an integer, so we'll get the wrong value if the browser is scaling.  We also have to round to two decimal places
            // b\c the grid rounds its values to 2 places, and so if the grid is reporting a column at 13.35 the browswer could be reporting a width of 13.34754, 
            // and it'd -look- like it doesnt fit but it does once rounded.
            var mainAreaWidth = Number(Math.round(agGridApi.pg.gridBodyViewport.getBoundingClientRect().width + "e2") + "e-2");
            agGridApi.getDisplayedLeftColumns().concat(agGridApi.getDisplayedRightColumns()).forEach(function (pinned) { mainAreaWidth -= pinned.actualWidth; });

            // We grant a little extra space for the columns than is physically there.  Sometimes the timings of the resizing calls get weird with ag-grid and the columns
            // seem to not fit even though they do, and scrollbars quickly flash on and off.  This seems to solve it.
            var tolerancePx = 4;

            return lastMainRight <= mainAreaWidth + tolerancePx;
        }

        //
        // Indicates if the current set of visible rows fully fit within the grid width without needing a scrollbar
        //
        function _doRowsFitWithinGrid(agGridApi) {

            var { nodeHeight, nodeCount } = getTotalNodeHeight(_.bind(agGridApi.forEachNodeAfterFilterAndSort, agGridApi));
            var mainAreaHeight = Number(Math.round(agGridApi.pg.gridBodyViewport.getBoundingClientRect().height + "e2") + "e-2");

            return nodeHeight <= mainAreaHeight;
        }

        //
        // Indicates if the grid is visible
        //
        function _isGridVisible(agGridApi) {

            var gridBody = $(agGridApi.pg.gridBody);
            var isVisible = gridBody.width() > 0 && gridBody.height() > 0;

            return isVisible;
        }

        //
        // Prepare the gridProperties values for hooking up keyboard navigation.  Done before the grid is initialized.
        //
        function _prepareKeyboardNavigation(gridProperties) {

            // Hookup keyboard events.  The grid doesn't expose event listeners we can hook up to for this, the only way is to assign the listeners
            // to the grid options before the grid is initialized
            gridProperties.navigateToNextCell = _onNavigateToNextCell.bind(gridProperties);
            gridProperties.tabToNextCell = _onTabToNextCell.bind(gridProperties);
        }

        //
        // Grid custom context menu
        // 
        function getContextMenuItems(params) {

            var agGridApi = params.api;
            var menuItems = agGridApi.pg.gridOptions.context["_lrs/contextMenuItems"];

            return menuItems;
        }

        //
        // Callback called by the grid when the user is using keyboard navigation (arrows)
        //
        function _onNavigateToNextCell(params) {

            var agGridApi = this.api;
            var gridProperties = this;

            // The arrow navigation handler is used only to select the row that is being navigated to.  So we don't do this if we aren't doing row
            // selection in the first place.
            if (gridProperties.rowSelection) {

                var KEY_UP = 38;
                var KEY_DOWN = 40;

                var previousRowIndex = params.previousCellPosition.rowIndex;

                // If going up or down...
                if (params.key == KEY_DOWN || params.key == KEY_UP) {

                    var nextRowIndex = previousRowIndex + ((params.key == KEY_DOWN) ? 1 : -1);

                    // Don't take it out of bounds...
                    if (nextRowIndex >= 0 && nextRowIndex < agGridApi.getDisplayedRowCount()) {

                        // Select the next row.  Deselect the previous row unless shift is down (this really
                        // only matters for multi-selection)
                        agGridApi.forEachNode(function (node) {
                            if (nextRowIndex === node.rowIndex) {
                                node.setSelected(true);
                            }
                            else if (!params.event.shiftKey) {
                                node.setSelected(false);
                            }
                        });
                    }
                }
            }

            // Move to the next cell as expected
            return params.nextCellPosition;
        }

        //
        // Callback called by the grid when the user is using tab navigation
        //
        function _onTabToNextCell(params) {

            var agGridApi = this.agGridApi;
            var gridProperties = this;

            var previousCell = params.previousCellPosition;
            var previousRowIndex = previousCell.rowIndex;

            var nextCell;

            // If we are allowing editing at the cell level, then we proceed with what the grid wanted as the next cell
            // OR we are editing right now
            if (gridProperties.context["_lrs/editing"] && params.editing) {

                nextCell = params.nextCellPosition;

                // This section makes sure we skip grand totals, and land on an editable cell
                if (nextCell) {

                    // Grand totals row doesn't count
                    if (nextCell && nextCell.rowPinned == "bottom") {
                        nextCell = null;
                    }

                    // Make sure the next cell is editable, otherwise we won't move.  ag-grid changed something moving from v26 -> v27, this used to work automatically
                    if (nextCell) {
                        nextCell = _getNextEditableCell(agGridApi, nextCell, params.backwards);
                    }
                }

                // This section makes sure we skip over deleted rows when tabbing to the next row
                if (nextCell) {

                   var nextRowIndex = nextCell.rowIndex;

                    // While the current row is deleted, and there are still more rows, move to the next row
                    while (
                        nextRowIndex >= 0 &&
                        nextRowIndex < agGridApi.getDisplayedRowCount() &&
                        agGridApi.getDisplayedRowAtIndex(nextRowIndex).data.__state == InlineEditingState.deleted) {

                        nextRowIndex = nextRowIndex + (params.backwards ? -1 : 1);
                    }

                    // if we've changed indices... 
                    if (nextRowIndex != nextCell.rowIndex) {

                        // If we're in bounds, then that's our next row to edit on
                        if (
                            nextRowIndex >= 0 &&
                            nextRowIndex < agGridApi.getDisplayedRowCount()) {

                            nextCell = {
                                rowIndex: nextRowIndex,
                                rowPinned: agGridApi.getDisplayedRowAtIndex(nextRowIndex).rowPinned,
                                column: _getFirstEditableColumn(agGridApi, nextRowIndex, params.backwards)
                            };
                        }

                        // If we are out of bounds, then their is no next
                        else {
                            nextCell = null;
                        }
                    }
                }

                // If there is no next cell, and tabToAdd is on, and we aren't moving backwards, we add the new row now
                if (nextCell == null && !params.backwards && gridProperties.context["_lrs/editing/tabToAdd"]) {
                    var added = _onInlineEditingAddRow.call(agGridApi);

                    nextCell = {
                        rowIndex: added.rowIndex,
                        column: _getFirstEditableColumn(agGridApi, added.rowIndex)
                    };
                }

                // If nextCell still null, we may not have the option to add rows
                // commit the current row as we're now tabbing off the grid.
                // (Kind of like how we "Listen for clicks anywhere" and stopEditing if outside the grid.)
                // Applicable when form is submitted in other way ("Enter" key) and also provides visual styling of committed row.
                if (nextCell == null) {
                    // "false" means keep the new value (aka save)
                    agGridApi.stopEditing(false);
                }
            }

            // Otherwise if doing full rows at a time (and not actively editing), we keep the column the same and move up or down a row
            else {

                var nextRowIndex = params.backwards ? previousRowIndex - 1 : previousRowIndex + 1;

                // Clamp to available rows
                nextRowIndex = Math.min(Math.max(nextRowIndex, 0), agGridApi.getDisplayedRowCount() - 1);

                nextCell = {
                    rowIndex: nextRowIndex,
                    column: previousCell.column,
                };
            }

            // Don't mess with the selected rows if selection isn't enabled
            if (gridProperties.rowSelection) {

                var selectedRowIndex = nextCell != null ? nextCell.rowIndex : -1;

                // When tabbing only the target row gets selected, all others get cleared, event for multi-selection.  When tabbing
                // the shift key controls moving up\down, so it doesn't control single\multi select.
                agGridApi.forEachNode(function (node) {
                    node.setSelected(selectedRowIndex === node.rowIndex);
                });

            }

            // If we have a next cell to navigate to, use it. Otherwise a return of "true" means stay in the current cell, 
            // or "false" means let the browser handle it (tab to the next element in the page)
            return nextCell ? nextCell : false;
        }

        //
        // Callback called by the grid when a column has been pinned
        //
        function _onColumnPinned(event) {

            var allColumns = event.api.getAllGridColumns();

            var fixedColumns = allColumns.filter(function (column) {
                return column.getColDef().lockPosition;
            });

            var nonFixedColumns = allColumns.filter(function (column) {
                return !column.getColDef().lockPosition;
            });

            var pinnedColumns = nonFixedColumns.filter(function (column) {
                return column.getPinned() === 'left';
            });

            var pinTheFixedColumns =
                // If there are now any pinned columns, make sure the fixed columns get pinned
                pinnedColumns.length > 0 ||
                // Or if the column being marked as pinned is a fixed column, pin all the fixed columns.  Doing it this
                // way makes it so that if a fixed column gets unpinned, 'pinnedColumns.length' is zero, and they
                // all get unpinned.
                (event.column.getColDef().lockPosition && event.pinned);

            // Pin or unpin the fixed columns
            event.api.setColumnsPinned(fixedColumns, pinTheFixedColumns);
        }

        //
        // New in ag-31, callback called by the grid when the grid is planning to automatically unpin columns like the asshole that it is when
        // the browser gets resized.
        //
        function processUnpinnedColumns(params) {
            // Return the list of columns to automatically unpin - none
            return [];
        }

        // Exported public API
        var exports = {
            initialize,
            update,
            getNameValueName,
            getValueAsPercent,
            getContextMenuItems,
            getDateAtMidnight,
            processExportCellValue,
            processCopyCellValue,
            processUnpinnedColumns,
            modelErrorTooltip,
        };

        return exports;
    }
);